/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey, page = 1, perPage, sortOrder } = {}) {
    const params = new URLSearchParams();
    params.append('page', page);
    if (perPage) params.append('per_page', perPage);
    if (searchKey) params.append('search', searchKey);
    if (sortOrder) params.append('sort_order', sortOrder);
    return axios.get(`${this.url}?${params}`);
  }
}

export default new CannedResponse();
